module.exports = __webpack_public_path__ + "img/Schlauchboot.fe98d0c5.svg";